// import $ from 'jquery';

$('[data-toggle="filter-list"]').on("click", function(event) {
    event.preventDefault();

    $(this).toggleClass('active');
});


$('[data-toggle="filter-block"]').on("click", function(event) {
    event.preventDefault();

    $(this).toggleClass('active');
    $(this).next(".filter").toggleClass('active');
});